"use strict";

import { on } from '@elements/dom-utils';
import {onFind} from '@elements/init-modules-in-scope';

export function init() {
    // This script rerenders the item after it has been loaded to fix position: fixed; bottom: 0; issue in some Agents
    // There is no userAgent condition for specific userAgents because it is unknown in wich Agents the issue occurs
    if (window.matchMedia('(max-width: 767px)').matches) {
        onFind('.js-rerender-item', element => {
            on('load', () => {
                element.style.display = 'none';
                setTimeout(() => {
                    element.style.display = 'block';
                }, 1)
            }, window);
        });
    }
}